<template>
  <div id="userLayout" :class="['user-layout-wrapper', device]">
    <div class="container">
      <div class="top">
        <!-- <div class="header">
          <a href="/">
            <img src="~@/assets/logo.png" width="190px" height="62px" class="logo" alt="logo">
            <span class="title"></span>
          </a>
        </div> -->
        <div class="desc">
          <!-- 电商一体化业务中台 -->
          <!-- 企业微信综合管理系统 -->
          {{ title }}
        </div>
      </div>

      <route-view></route-view>

      <div class="footer">
        <div class="links">
          <!--<a href="" target="_blank">帮助</a>
          <a href="" target="_blank">隐私</a>
          <a href="" target="_blank">条款</a>-->
        </div>
        <div class="copyright">Copyright &copy; 2006-2020</div>
      </div>
    </div>
  </div>
</template>

<script>
import RouteView from '@/components/layouts/RouteView';
import { mixinDevice } from '@/utils/mixin.js';
import Vue from 'vue';
import { MIDDLE_PLATFORM_LOGIN_TITLE } from '@/store/mutation-types';
export default {
  name: 'UserLayout',
  components: { RouteView },
  mixins: [mixinDevice],
  data() {
    return {
      title: '',
    };
  },
  mounted() {
    document.body.classList.add('userLayout');
    this.title = Vue.ls.get(MIDDLE_PLATFORM_LOGIN_TITLE);
  },
  beforeDestroy() {
    document.body.classList.remove('userLayout');
  },
};
</script>

<style lang="less" scoped>
#userLayout.user-layout-wrapper {
  height: 100%;

  &.mobile {
    .container {
      .main {
        max-width: 368px;
        width: 98%;
      }
    }
  }

  .container {
    width: 100%;
    min-height: 100%;
    background: #f0f2f5 url(~@/assets/background.svg) no-repeat 50%;
    background-size: 100%;
    padding: 110px 0 144px;
    position: relative;

    a {
      text-decoration: none;
    }

    .top {
      text-align: center;

      .header {
        height: 62px;
        line-height: 62px;

        .badge {
          position: absolute;
          display: inline-block;
          line-height: 1;
          vertical-align: middle;
          margin-left: -12px;
          margin-top: -10px;
          opacity: 0.8;
        }

        .logo {
          height: 62px;
          vertical-align: top;
          margin-right: 0px;
          border-style: none;
        }

        .title {
          font-size: 33px;
          color: rgba(0, 0, 0, 0.85);
          font-family: 'Chinese Quote', -apple-system, BlinkMacSystemFont,
            'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei',
            'Helvetica Neue', Helvetica, Arial, sans-serif, 'Apple Color Emoji',
            'Segoe UI Emoji', 'Segoe UI Symbol';
          font-weight: 600;
          position: relative;
          top: 2px;
        }
      }
      .desc {
        font-size: 24px;
        color: rgba(0, 0, 0, 0.45);
        margin-top: 12px;
        margin-bottom: 40px;
      }
    }

    .main {
      min-width: 260px;
      width: 368px;
      margin: 0 auto;
    }

    .footer {
      position: absolute;
      width: 100%;
      bottom: 0;
      padding: 0 16px;
      margin: 48px 0 24px;
      text-align: center;

      .links {
        margin-bottom: 8px;
        font-size: 14px;
        a {
          color: rgba(0, 0, 0, 0.45);
          transition: all 0.3s;
          &:not(:last-child) {
            margin-right: 40px;
          }
        }
      }
      .copyright {
        color: rgba(0, 0, 0, 0.45);
        font-size: 14px;
      }
    }
  }
}
</style>
